
// import React, { useEffect, useState, useRef } from "react";
// import { Helmet } from "react-helmet-async";
// import {
//   Container,
//   Stack,
//   Typography,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   CircularProgress,
//   Box,
//   Avatar,
//   Rating,
// } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Swal from "sweetalert2";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// import { projectdata } from "src/redux/slice/project";
// import { teamdata } from "src/redux/slice/team";
// import { Url } from "src/url/url";
// import axios from "axios";

// const EditTeamPage = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { projectId } = useParams();
//   const roleAllData = useSelector((store) => store.role.data);
//   const staffAllData = useSelector((store) => store.staff.data.data);
//   const packageAllData = useSelector((store) => store.package.data);
//   const [singelProject, setSingleProject] = useState();
//   const [createDate, setCreateDate] = useState({});
//   const [assistant, setAssistant] = useState({
//     role: "",
//     staffId: "",
//     staffName: "",
//   });
//   const [inputTeam, setInputTeam] = useState([
//     { role: "", staffId: "", staffName: "" },
//   ]);
//   const [selectedDate, setSelectedDate] = useState(null); // ✅ Start Date
//   const [endDate, setEndDate] = useState(null); // ✅ End Date added here
//   const datePickerRef = useRef(null);

//   const handleDateChange = (date) => setSelectedDate(date);
//   const handleEndDateChange = (date) => setEndDate(date); // ✅ handle end date

//   const getProjectFunc = async (projectId) => {
//     const response = await axios.get(`${Url}/project/projectDetail/${projectId}`);
//     setSingleProject(response?.data);
//     const dateString = response?.data.createdAt;
//     const date = new Date(dateString);
//     const monthNames = [
//       "January",
//       "February",
//       "March",
//       "April",
//       "May",
//       "June",
//       "July",
//       "August",
//       "September",
//       "October",
//       "November",
//       "December",
//     ];
//     setCreateDate({
//       day: String(date.getDate()).padStart(2, "0"),
//       month: monthNames[date.getMonth()],
//       year: date.getFullYear(),
//     });
//   };

//   const handleRoleChange = (e, index, selectedRole) => {
//     const updatedInputTeam = [...inputTeam];
//     updatedInputTeam[index].role = selectedRole;
//     updatedInputTeam[index].staffId = "";
//     updatedInputTeam[index].staffName = "";
//     setInputTeam(updatedInputTeam);
//   };

//   const handleStaffChange = (e, index) => {
//     const staff = JSON.parse(e.target.value);
//     const updatedInputTeam = [...inputTeam];
//     updatedInputTeam[index].staffId = staff._id;
//     updatedInputTeam[index].staffName = `${staff.firstName} ${staff.lastName}`;
//     setInputTeam(updatedInputTeam);
//   };

//   const handleAddMore = (e) => {
//     e.preventDefault();
//     setInputTeam([...inputTeam, { role: "", staffId: "", staffName: "" }]);
//   };

//   const handleRemovePair = (e, indexToRemove) => {
//     e.preventDefault();
//     setInputTeam(inputTeam.filter((_, i) => i !== indexToRemove));
//   };

//   // ✅ Updated CreateTeam function with endDate
//   const CreateTeam = async (data, projectId, startDate, endDate) => {
//     try {
//       const responseData = await axios.post(`${Url}/team/add/${projectId}`, {
//         ...data,
//         startDate,
//         endDate, // ✅ sending to backend
//       });
//       Swal.fire({
//         position: "top-end",
//         icon: "success",
//         title: "Team created successfully",
//         showConfirmButton: false,
//         timer: 1500,
//       });
//       return responseData;
//     } catch (error) {
//       const message =
//         error?.response?.data?.message ||
//         "Something went wrong while creating the team.";
//       Swal.fire({
//         position: "top-end",
//         icon: "error",
//         title: message,
//         showConfirmButton: true,
//         timer: 2000,
//       });
//       throw new Error(message);
//     }
//   };

//   // ✅ Updated submit to include endDate
//   const submit = async (e) => {
//     e.preventDefault();
//     const requiredTeamCount = singelProject?.service?.length || 0;

//     if (!assistant?.staffId || !selectedDate || !endDate) {
//       Swal.fire({
//         position: "top-end",
//         icon: "warning",
//         title: "All fields are required (including start & end date)",
//         showConfirmButton: false,
//         timer: 1500,
//       });
//       return;
//     }

//     if (inputTeam.length < requiredTeamCount) {
//       Swal.fire({
//         position: "center",
//         icon: "warning",
//         title: `Please assign at least ${requiredTeamCount} team member(s)`,
//         showConfirmButton: false,
//         timer: 2000,
//       });
//       return;
//     }

//     const data = { assistant, team: inputTeam };
//     await CreateTeam(data, projectId, selectedDate, endDate); // ✅ both dates
//     dispatch(projectdata());
//     dispatch(teamdata());
//     navigate("/dashboard/new-project");
//   };

//   useEffect(() => {
//     getProjectFunc(projectId);
//   }, []);

//   return (
//     <>
//       <ToastContainer />
//       <Helmet>
//         <title>Project without team</title>
//       </Helmet>

//       <Container>
//         <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
//           <Typography variant="h4" className="text-dark fw-bold">
//             Make Your Dream Team
//           </Typography>
//         </Stack>

//         <div className="team-form-section bg-white p-4 rounded-4 shadow-lg mb-5">
//           <form>
//             <h5 className="text-primary mb-4 fw-semibold">👥 Choose Your Team</h5>

//             {/* === Assistant Select === */}
//             <div className="row mb-4">
//               <div className="col-md-4">
//                 <input type="text" value="assistant" className="form-control" readOnly />
//               </div>
//               <div className="col-md-4">
//                 <FormControl fullWidth size="small">
//                   <InputLabel>Select Assistant</InputLabel>
//                   <Select
//                     value={assistant.staffId ? JSON.stringify(assistant) : ""}
//                     label="Select Assistant"
//                     onChange={(e) => {
//                       const staff = JSON.parse(e.target.value);
//                       setAssistant({
//                         role: "assistant",
//                         staffId: staff._id,
//                         staffName: `${staff.firstName} ${staff.lastName}`,
//                       });
//                     }}
//                     renderValue={(selected) => {
//                       if (!selected) return "Select Assistant";
//                       const staff = JSON.parse(selected);
//                       return `${staff.staffName || staff.firstName}`;
//                     }}
//                   >
//                     {staffAllData
//                       ?.filter((s) => s.role === "assistant")
//                       .map((staffVal, idx) => {
//                         const running = staffVal.projectIds?.length || 0;
//                         const progress = Math.min((running / 20) * 100, 100);
//                         const isOverloaded = running > 20;

//                         return (
//                           <MenuItem
//                             key={idx}
//                             value={JSON.stringify(staffVal)}
//                             disabled={isOverloaded}
//                             sx={{
//                               display: "flex",
//                               alignItems: "center",
//                               gap: 1.5,
//                               opacity: isOverloaded ? 0.6 : 1,
//                             }}
//                           >
//                             <Avatar
//                               sx={{
//                                 width: 28,
//                                 height: 28,
//                                 bgcolor: "primary.main",
//                                 fontSize: 13,
//                               }}
//                             >
//                               {staffVal.firstName?.charAt(0)?.toUpperCase()}
//                             </Avatar>
//                             <Box flexGrow={1}>
//                               <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                                 {staffVal.firstName} {staffVal.lastName}
//                               </Typography>
//                               <Rating
//                                 name="read-only"
//                                 value={Number(staffVal.avgRating || 0)}
//                                 precision={0.5}
//                                 readOnly
//                                 size="small"
//                               />
//                             </Box>

//                             <Box position="relative" display="inline-flex">
//                               <CircularProgress
//                                 variant="determinate"
//                                 value={progress}
//                                 size={28}
//                                 thickness={5}
//                                 sx={{
//                                   color:
//                                     progress < 50
//                                       ? "success.main"
//                                       : progress < 80
//                                       ? "warning.main"
//                                       : "error.main",
//                                 }}
//                               />
//                               <Box
//                                 top={0}
//                                 left={0}
//                                 bottom={0}
//                                 right={0}
//                                 position="absolute"
//                                 display="flex"
//                                 alignItems="center"
//                                 justifyContent="center"
//                               >
//                                 <Typography
//                                   variant="caption"
//                                   component="div"
//                                   color="text.secondary"
//                                   fontSize={10}
//                                 >
//                                   {running}
//                                 </Typography>
//                               </Box>
//                             </Box>
//                           </MenuItem>
//                         );
//                       })}
//                   </Select>
//                 </FormControl>
//               </div>
//             </div>

//             {/* === Team Members === */}
//             {inputTeam.map((pair, idx) => (
//               <div key={idx} className="row mb-3 align-items-center">
//                 <div className="col-md-4">
//                   <select
//                     className="form-select"
//                     value={pair.role}
//                     onChange={(e) => handleRoleChange(e, idx, e.target.value)}
//                   >
//                     <option value="">Select Role</option>
//                     {roleAllData.map((role) => (
//                       <option key={role._id} value={role.role}>
//                         {role.role}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className="col-md-4">
//                   {pair.role && (
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Select Staff</InputLabel>
//                       <Select
//                         value={pair.staffId ? JSON.stringify(pair) : ""}
//                         label="Select Staff"
//                         onChange={(e) => handleStaffChange(e, idx)}
//                         renderValue={(selected) => {
//                           if (!selected) return "Select Staff";
//                           const staff = JSON.parse(selected);
//                           return `${staff.staffName || staff.firstName}`;
//                         }}
//                       >
//                         {staffAllData
//                           ?.filter((staff) => staff.role === pair.role)
//                           .map((staff) => {
//                             const running = staff.projectIds?.length || 0;
//                             const isAssistant =
//                               staff.role?.toLowerCase() === "assistant";
//                             const limit = isAssistant ? 20 : 10;
//                             const progress = Math.min((running / limit) * 100, 100);
//                             const isOverloaded = running >= limit;

//                             return (
//                               <MenuItem
//                                 key={staff._id}
//                                 value={JSON.stringify(staff)}
//                                 disabled={isOverloaded}
//                                 sx={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: 1.5,
//                                   opacity: isOverloaded ? 0.6 : 1,
//                                 }}
//                               >
//                                 <Avatar
//                                   sx={{
//                                     width: 28,
//                                     height: 28,
//                                     bgcolor: "primary.main",
//                                     fontSize: 13,
//                                   }}
//                                 >
//                                   {staff.firstName?.charAt(0)?.toUpperCase()}
//                                 </Avatar>

//                                 <Box flexGrow={1}>
//                                   <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                                     {staff.firstName} {staff.lastName}
//                                   </Typography>
//                                   <Rating
//                                     name="read-only"
//                                     value={Number(staff.avgRating || 0)}
//                                     precision={0.5}
//                                     readOnly
//                                     size="small"
//                                   />
//                                 </Box>

//                                 <Box position="relative" display="inline-flex">
//                                   <CircularProgress
//                                     variant="determinate"
//                                     value={progress}
//                                     size={28}
//                                     thickness={5}
//                                     sx={{
//                                       color:
//                                         progress < 50
//                                           ? "success.main"
//                                           : progress < 80
//                                           ? "warning.main"
//                                           : "error.main",
//                                     }}
//                                   />
//                                   <Box
//                                     top={0}
//                                     left={0}
//                                     bottom={0}
//                                     right={0}
//                                     position="absolute"
//                                     display="flex"
//                                     alignItems="center"
//                                     justifyContent="center"
//                                   >
//                                     <Typography
//                                       variant="caption"
//                                       component="div"
//                                       color="text.secondary"
//                                       fontSize={10}
//                                     >
//                                       {running}
//                                     </Typography>
//                                   </Box>
//                                 </Box>
//                               </MenuItem>
//                             );
//                           })}
//                       </Select>
//                     </FormControl>
//                   )}
//                 </div>

//                 <div className="col-md-4">
//                   {inputTeam.length > 1 && (
//                     <button
//                       className="btn btn-outline-danger"
//                       onClick={(e) => handleRemovePair(e, idx)}
//                     >
//                       Remove
//                     </button>
//                   )}
//                 </div>
//               </div>
//             ))}

//             <div className="mb-3">
//               <button className="btn btn-outline-primary me-2" onClick={handleAddMore}>
//                 Add More +
//               </button>
//             </div>

//             {/* ✅ Start + End Date Section */}
//             <div className="row">
//               <div className="col-md-6 mb-4">
//                 <label className="form-label text-primary fs-14">📅 Select Start Date</label>
//                 <DatePicker
//                   ref={datePickerRef}
//                   selected={selectedDate}
//                   onChange={handleDateChange}
//                   dateFormat="dd/MM/yyyy"
//                   className="form-control"
//                   placeholderText="dd/mm/yyyy"
//                   selectsStart
//                   startDate={selectedDate}
//                   endDate={endDate}
//                 />
//               </div>

//               <div className="col-md-6 mb-4">
//                 <label className="form-label text-primary fs-14">📅 Select End Date</label>
//                 <DatePicker
//                   selected={endDate}
//                   onChange={handleEndDateChange}
//                   dateFormat="dd/MM/yyyy"
//                   className="form-control"
//                   placeholderText="dd/mm/yyyy"
//                   selectsEnd
//                   startDate={selectedDate}
//                   endDate={endDate}
//                   minDate={selectedDate}
//                 />
//               </div>
//             </div>

//             <div>
//               <button className="btn btn-success" onClick={(e) => submit(e)}>
//                 Create Team <i className="fa-solid fa-user-plus ms-2"></i>
//               </button>
//             </div>
//           </form>
//         </div>
//       </Container>
//     </>
//   );
// };

// export default EditTeamPage;








// import React, { useEffect, useState } from 'react';
// import { Helmet } from 'react-helmet-async';
// import { useParams, useNavigate } from 'react-router-dom';
// import { Container, Typography, Stack } from '@mui/material';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { Url } from 'src/url/url';


// const EditTeamPage = () => {
//   const { projectId } = useParams(); // team ID from route /dashboard/edit-team/:id
//   const navigate = useNavigate();
// alert('ID is: ' + projectId);
// console.log("id",projectId)
//   // ─── State ───────────────────────────────────────────────────────────────
//   const [loading, setLoading]           = useState(true);
//   const [submitLoading, setSubmitLoading] = useState(false);
//   const [staffList, setStaffList]       = useState([]);

//   // Assistant
//   const [assistant, setAssistant] = useState({
//     staffId: '',
//     staffName: '',
//     role: 'assistant',
//   });

//   // Team members array
//   const [teamMembers, setTeamMembers] = useState([
//     { staffId: '', staffName: '', role: '' },
//   ]);

//   // Dates
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate]     = useState('');

//   // ─── Fetch existing team data ─────────────────────────────────────────────
//   useEffect(() => {
//     if (!id) return;
//     fetchTeamData();
//     fetchStaffList();
//   }, [id]);

//   // const fetchTeamData = async () => {
//   //   setLoading(true);
//   //   try {
//   //     const res = await axios.get(`${Url}/team/single/${id}`);
//   //     const data = res.data;

//   //     // Pre-fill assistant
//   //     if (data.assistant) {
//   //       setAssistant({
//   //         staffId:   data.assistant.staffId?._id || data.assistant.staffId || '',
//   //         staffName: data.assistant.staffName || '',
//   //         role:      data.assistant.role || 'assistant',
//   //       });
//   //     }

//   //     // Pre-fill team members
//   //     if (data.team && data.team.length > 0) {
//   //       setTeamMembers(
//   //         data.team.map((m) => ({
//   //           staffId:   m.staffId?._id || m.staffId || '',
//   //           staffName: m.staffName || '',
//   //           role:      m.role || '',
//   //         }))
//   //       );
//   //     }

//   //     // Dates are on Project document, not Team — fetch using projectId
//   //     if (data.projectId) {
//   //       try {
//   //         const projectRes = await axios.get(`${Url}/project/${data.projectId}`);
//   //         const project = projectRes.data;
//   //         if (project.startAt) setStartDate(project.startAt.slice(0, 10));
//   //         if (project.endAt)   setEndDate(project.endAt.slice(0, 10));
//   //       } catch (projErr) {
//   //         console.error('Error fetching project dates:', projErr);
//   //       }
//   //     }

//   //   } catch (err) {
//   //     console.error('Error fetching team:', err);
//   //     toast.error('Failed to load team data');
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };


// const fetchTeamData = async () => {
//   setLoading(true);
//   try {
//     const res = await axios.get(`${Url}/team/single/${projectId}`);
//     const data = res.data;

//     console.log('Team data:', data); // debug ke liye

//     // Pre-fill assistant
//     if (data.assistant) {
//       setAssistant({
//         staffId:   String(data.assistant.staffId?._id || data.assistant.staffId || ''),
//         staffName: data.assistant.staffName || '',
//         role:      data.assistant.role || 'assistant',
//       });
//     }

//     // Pre-fill team members
//     if (data.team && data.team.length > 0) {
//       setTeamMembers(
//         data.team.map((m) => ({
//           staffId:   String(m.staffId?._id || m.staffId || ''),
//           staffName: m.staffName || '',
//           role:      m.role || '',
//         }))
//       );
//     }

//     // ✅ projectId fetch try-catch alag karo — error pe loading stuck na ho
//     if (data.projectId) {
//       try {
//         const projectRes = await axios.get(`${Url}/project/${data.projectId}`);
//         const project = projectRes.data;
//         if (project.startAt) setStartDate(project.startAt.slice(0, 10));
//         if (project.endAt)   setEndDate(project.endAt.slice(0, 10));
//       } catch (projErr) {
//         console.error('Project fetch error:', projErr);
//         // ✅ Yahan toast nahi, silently ignore karo
//       }
//     }

//   } catch (err) {
//     console.error('Error fetching team:', err);
//     toast.error('Failed to load team data');
//   } finally {
//     setLoading(false); // ✅ Yeh hamesha call hoga
//   }
// };






//   const fetchStaffList = async () => {
//     try {
//       const res = await axios.get(`${Url}/team/showStaffClient`);
//       setStaffList(res.data || []);
//     } catch (err) {
//       console.error('Error fetching staff:', err);
//     }
//   };

//   // ─── Assistant handlers ───────────────────────────────────────────────────
//   const handleAssistantChange = (e) => {
//     const selectedId = e.target.value;
//     const staff = staffList.find((s) => String(s._id) === String(selectedId));
//     setAssistant({
//       staffId:   selectedId,
//       staffName: staff ? staff.name || staff.firstName || '' : '',
//       role:      'assistant',
//     });
//   };

//   // ─── Team member handlers ─────────────────────────────────────────────────
//   const handleMemberChange = (index, field, value) => {
//     const updated = [...teamMembers];
//     if (field === 'staffId') {
//       const staff = staffList.find((s) => String(s._id) === String(value));
//       updated[index].staffId   = value;
//       updated[index].staffName = staff ? staff.name || staff.firstName || '' : '';
//     } else {
//       updated[index][field] = value;
//     }
//     setTeamMembers(updated);
//   };

//   const handleAddMember = () => {
//     setTeamMembers([...teamMembers, { staffId: '', staffName: '', role: '' }]);
//   };

//   const handleRemoveMember = (index) => {
//     if (teamMembers.length === 1) {
//       toast.warning('At least one team member is required');
//       return;
//     }
//     setTeamMembers(teamMembers.filter((_, i) => i !== index));
//   };

//   // ─── Submit ───────────────────────────────────────────────────────────────
//   const handleSubmit = async () => {
//     // Validation
//     if (!assistant.staffId) {
//       toast.error('Please select an assistant');
//       return;
//     }
//     for (let i = 0; i < teamMembers.length; i++) {
//       if (!teamMembers[i].staffId || !teamMembers[i].role) {
//         toast.error(`Please fill all fields for member ${i + 1}`);
//         return;
//       }
//     }
//     if (!startDate || !endDate) {
//       toast.error('Please select start and end dates');
//       return;
//     }

//     setSubmitLoading(true);
//     try {
//       const payload = {
//         assistant,
//         team: teamMembers,
//         startDate,
//         endDate,
//       };

//       const res = await axios.put(`${Url}/team/update/${id}`, payload);

//       if (res.data.message) {
//         toast.success('Team updated successfully!');
//         setTimeout(() => navigate('/dashboard/new-project'), 1500);
//       }
//     } catch (err) {
//       console.error('Update error:', err);
//       toast.error(err.response?.data?.message || 'Failed to update team');
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   // ─── Roles dropdown options ───────────────────────────────────────────────
//   const roleOptions = [
//     'Developer',
//     'Designer',
//     'SEO Specialist',
//     'Content Writer',
//     'Project Manager',
//     'QA Tester',
//     'Marketing',
//     'Other',
//   ];

//   // ─── Render ───────────────────────────────────────────────────────────────
//   return (
//     <>
//       <ToastContainer />
//       <Helmet>
//         <title>Edit Team</title>
//       </Helmet>

//       <Container maxWidth="lg">
//         <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
//           <Typography variant="h4" gutterBottom>
//             ✏️ Edit Team
//           </Typography>
//           <button
//             className="btn btn-outline-secondary btn-sm rounded-pill"
//             onClick={() => navigate(-1)}
//           >
//             ← Back
//           </button>
//         </Stack>

//         {loading ? (
//           <div className="d-flex justify-content-center align-items-center py-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <span className="ms-3 text-muted">Loading team data...</span>
//           </div>
//         ) : (
//           <div className="card shadow-sm rounded-4 border-0">
//             <div className="card-body p-4">

//               {/* ── Section: Choose Assistant ── */}
//               <div className="mb-5">
//                 <h5 className="fw-bold text-primary mb-3">
//                   <i className="bi bi-person-badge-fill me-2"></i>
//                   Choose Your Assistant
//                 </h5>

//                 <div className="row g-3 align-items-center">
//                   {/* Label */}
//                   <div className="col-md-3">
//                     <input
//                       type="text"
//                       className="form-control bg-light"
//                       value="assistant"
//                       readOnly
//                     />
//                   </div>

//                   {/* Select Assistant */}
//                   <div className="col-md-5">
//                     <select
//                       className="form-select"
//                       value={assistant.staffId}
//                       onChange={handleAssistantChange}
//                     >
//                       <option value="">Select Assistant</option>
//                       {staffList.map((staff) => (
//                         <option key={staff._id} value={staff._id}>
//                           {staff.name || staff.firstName} (ID: {staff._id})
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   {/* Role (fixed) */}
//                   <div className="col-md-4">
//                     <input
//                       type="text"
//                       className="form-control bg-light"
//                       value="Assistant"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── Section: Team Members ── */}
//               <div className="mb-5">
//                 <h5 className="fw-bold text-primary mb-3">
//                   <i className="bi bi-people-fill me-2"></i>
//                   Team Members
//                 </h5>

//                 {teamMembers.map((member, index) => (
//                   <div
//                     key={index}
//                     className="row g-3 align-items-center mb-3 p-3 rounded-3"
//                     style={{ background: '#f8f9fa', border: '1px solid #e9ecef' }}
//                   >
//                     {/* Member number */}
//                     <div className="col-auto">
//                       <span
//                         className="badge bg-primary rounded-circle d-flex align-items-center justify-content-center"
//                         style={{ width: 32, height: 32, fontSize: '0.85rem' }}
//                       >
//                         {index + 1}
//                       </span>
//                     </div>

//                     {/* Select Staff */}
//                     <div className="col-md-4">
//                       <select
//                         className="form-select"
//                         value={member.staffId}
//                         onChange={(e) => handleMemberChange(index, 'staffId', e.target.value)}
//                       >
//                         <option value="">Select Staff</option>
//                         {staffList.map((staff) => (
//                           <option key={staff._id} value={staff._id}>
//                             {staff.name || staff.firstName} (ID: {staff._id})
//                           </option>
//                         ))}
//                       </select>
//                     </div>

//                     {/* Select Role */}
//                     <div className="col-md-4">
//                       <select
//                         className="form-select"
//                         value={member.role}
//                         onChange={(e) => handleMemberChange(index, 'role', e.target.value)}
//                       >
//                         <option value="">Select Role</option>
//                         {roleOptions.map((role) => (
//                           <option key={role} value={role}>
//                             {role}
//                           </option>
//                         ))}
//                       </select>
//                     </div>

//                     {/* Remove Button */}
//                     <div className="col-auto">
//                       <button
//                         className="btn btn-outline-danger btn-sm rounded-circle"
//                         style={{ width: 36, height: 36 }}
//                         onClick={() => handleRemoveMember(index)}
//                         title="Remove member"
//                       >
//                         <i className="bi bi-trash3"></i>
//                       </button>
//                     </div>
//                   </div>
//                 ))}

//                 {/* Add More */}
//                 <button
//                   className="btn btn-outline-primary btn-sm rounded-pill mt-2"
//                   onClick={handleAddMember}
//                 >
//                   <i className="bi bi-plus-circle me-1"></i>
//                   Add More +
//                 </button>
//               </div>

//               {/* ── Section: Dates ── */}
//               <div className="mb-5">
//                 <h5 className="fw-bold text-primary mb-3">
//                   <i className="bi bi-calendar-range-fill me-2"></i>
//                   Project Duration
//                 </h5>

//                 <div className="row g-3">
//                   <div className="col-md-6">
//                     <label className="form-label text-muted fw-semibold">
//                       <i className="bi bi-calendar-check me-1"></i>
//                       Start Date
//                     </label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       value={startDate}
//                       onChange={(e) => setStartDate(e.target.value)}
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label text-muted fw-semibold">
//                       <i className="bi bi-calendar-x me-1"></i>
//                       End Date
//                     </label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       value={endDate}
//                       onChange={(e) => setEndDate(e.target.value)}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── Submit Button ── */}
//               <div className="d-flex gap-3">
//                 <button
//                   className="btn btn-success px-4 py-2 rounded-pill d-flex align-items-center gap-2"
//                   onClick={handleSubmit}
//                   disabled={submitLoading}
//                 >
//                   {submitLoading ? (
//                     <>
//                       <div className="spinner-border spinner-border-sm" role="status">
//                         <span className="visually-hidden">Loading...</span>
//                       </div>
//                       <span>Updating...</span>
//                     </>
//                   ) : (
//                     <>
//                       <i className="bi bi-check-circle-fill"></i>
//                       <span>Update Team</span>
//                     </>
//                   )}
//                 </button>

//                 <button
//                   className="btn btn-outline-secondary px-4 py-2 rounded-pill"
//                   onClick={() => navigate(-1)}
//                   disabled={submitLoading}
//                 >
//                   Cancel
//                 </button>
//               </div>

//             </div>
//           </div>
//         )}
//       </Container>
//     </>
//   );
// };

// export default EditTeamPage;









// import React, { useEffect, useState } from 'react';
// import { Helmet } from 'react-helmet-async';
// import { useParams, useNavigate } from 'react-router-dom';
// import { Container, Typography, Stack } from '@mui/material';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { Url } from 'src/url/url';

// const EditTeamPage = () => {
//   const { projectId } = useParams();
//   const navigate = useNavigate();

//   const [loading, setLoading]             = useState(true);
//   const [submitLoading, setSubmitLoading] = useState(false);
//   const [staffList, setStaffList]         = useState([]);

//   const [assistant, setAssistant] = useState({
//     staffId:   '',
//     staffName: '',
//     role:      'assistant',
//   });

//   const [teamMembers, setTeamMembers] = useState([
//     { staffId: '', staffName: '', role: '' },
//   ]);

//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate]     = useState('');

//   useEffect(() => {
//     if (!projectId) return;
//     fetchTeamData();
//     fetchStaffList();
//   }, [projectId]);

//   const fetchTeamData = async () => {
//     setLoading(true);
//     try {
//       const res  = await axios.get(`${Url}/team/single/${projectId}`);
//       const data = res.data;
// console.log(res)
//       // Pre-fill assistant
//       if (data.assistant) {
//         setAssistant({
//           staffId:   String(data.assistant.staffId?._id || data.assistant.staffId || ''),
//           staffName: data.assistant.staffName || '',
//           role:      data.assistant.role || 'assistant',
//         });
//       }

//       // Pre-fill team members
//       if (data.team && data.team.length > 0) {
//         setTeamMembers(
//           data.team.map((m) => ({
//             staffId:   String(m.staffId?._id || m.staffId || ''),
//             staffName: m.staffName || '',
//             role:      m.role || '', // ✅ exact value — "web developer" etc.
//           }))
//         );
//       }

//       // Fetch project dates
//       if (data.projectId) {
//         try {
//           const projectRes = await axios.get(`${Url}/project/${data.projectId}`);
//           const project    = projectRes.data;
//           if (project.startAt) setStartDate(project.startAt.slice(0, 10));
//           if (project.endAt)   setEndDate(project.endAt.slice(0, 10));
//         } catch (projErr) {
//           console.error('Project fetch error:', projErr);
//         }
//       }

//     } catch (err) {
//       console.error('Error fetching team:', err);
//       toast.error('Failed to load team data');
//     } finally {
//       setLoading(false);
//     }
//   };
// const fetchStaffList = async () => {
//   try {
//     const res = await axios.get(`${Url}/team/showStaffClient`);
//     setStaffList(res.data || []);
//   } catch (err) {
//     console.error('Error fetching staff:', err);
//   }
// };

//   const handleAssistantChange = (e) => {
//     const selectedId = e.target.value;
//     const staff      = staffList.find((s) => String(s._id) === String(selectedId));
//     setAssistant({
//       staffId:   selectedId,
//       staffName: staff ? staff.name || staff.firstName || '' : '',
//       role:      'assistant',
//     });
//   };

//   const handleMemberChange = (index, field, value) => {
//     const updated = [...teamMembers];
//     if (field === 'staffId') {
//       const staff              = staffList.find((s) => String(s._id) === String(value));
//       updated[index].staffId   = value;
//       updated[index].staffName = staff ? staff.name || staff.firstName || '' : '';
//     } else {
//       updated[index][field] = value;
//     }
//     setTeamMembers(updated);
//   };

//   const handleAddMember = () => {
//     setTeamMembers([...teamMembers, { staffId: '', staffName: '', role: '' }]);
//   };

//   const handleRemoveMember = (index) => {
//     if (teamMembers.length === 1) {
//       toast.warning('At least one team member is required');
//       return;
//     }
//     setTeamMembers(teamMembers.filter((_, i) => i !== index));
//   };

//   const handleSubmit = async () => {
//     if (!assistant.staffId) {
//       toast.error('Please select an assistant');
//       return;
//     }
//     for (let i = 0; i < teamMembers.length; i++) {
//       if (!teamMembers[i].staffId || !teamMembers[i].role) {
//         toast.error(`Please fill all fields for member ${i + 1}`);
//         return;
//       }
//     }
//     if (!startDate || !endDate) {
//       toast.error('Please select start and end dates');
//       return;
//     }

//     setSubmitLoading(true);
//     try {
//       const payload = {
//         assistant,
//         team: teamMembers,
//         startDate,
//         endDate,
//       };

//       const res = await axios.put(`${Url}/team/update/${projectId}`, payload);

//       if (res.data.message) {
//         toast.success('Team updated successfully!');
//         setTimeout(() => navigate('/dashboard/new-project'), 1500);
//       }
//     } catch (err) {
//       console.error('Update error:', err);
//       toast.error(err.response?.data?.message || 'Failed to update team');
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   const roleOptions = [
//     'web developer',
//     'Developer',
//     'Designer',
//     'SEO Specialist',
//     'Content Writer',
//     'Project Manager',
//     'QA Tester',
//     'Marketing',
//     'Other',
//   ];

//   return (
//     <>
//       <ToastContainer />
//       <Helmet>
//         <title>Edit Team</title>
//       </Helmet>

//       <Container maxWidth="lg">
//         <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
//           <Typography variant="h4" gutterBottom>
//             ✏️ Edit Team
//           </Typography>
//           <button
//             className="btn btn-outline-secondary btn-sm rounded-pill"
//             onClick={() => navigate(-1)}
//           >
//             ← Back
//           </button>
//         </Stack>

//         {loading ? (
//           <div className="d-flex justify-content-center align-items-center py-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <span className="ms-3 text-muted">Loading team data...</span>
//           </div>
//         ) : (
//           <div className="card shadow-sm rounded-4 border-0">
//             <div className="card-body p-4">

//               {/* ── Assistant ── */}
//               <div className="mb-5">
//                 <h5 className="fw-bold text-primary mb-3">
//                   <i className="bi bi-person-badge-fill me-2"></i>
//                   Choose Your Assistant
//                 </h5>
//                 <div className="row g-3 align-items-center">
//                   <div className="col-md-3">
//                     <input
//                       type="text"
//                       className="form-control bg-light"
//                       value="assistant"
//                       readOnly
//                     />
//                   </div>
//                   <div className="col-md-5">
//                     <select
//                       className="form-select"
//                       value={assistant.staffId}
//                       onChange={handleAssistantChange}
//                     >
//                       <option value="">Select Assistant</option>
//                       {staffList.map((staff) => (
//                         <option key={staff._id} value={String(staff._id)}>
//                           {staff.name || staff.firstName} (ID: {staff._id})
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div className="col-md-4">
//                     <input
//                       type="text"
//                       className="form-control bg-light"
//                       value="Assistant"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── Team Members ── */}
//               <div className="mb-5">
//                 <h5 className="fw-bold text-primary mb-3">
//                   <i className="bi bi-people-fill me-2"></i>
//                   Team Members
//                 </h5>

//                 {teamMembers.map((member, index) => (
//                   <div
//                     key={index}
//                     className="row g-3 align-items-center mb-3 p-3 rounded-3"
//                     style={{ background: '#f8f9fa', border: '1px solid #e9ecef' }}
//                   >
//                     <div className="col-auto">
//                       <span
//                         className="badge bg-primary rounded-circle d-flex align-items-center justify-content-center"
//                         style={{ width: 32, height: 32, fontSize: '0.85rem' }}
//                       >
//                         {index + 1}
//                       </span>
//                     </div>

//                     {/* ✅ String() se staffId match ensure */}
//                     <div className="col-md-4">
//                       <select
//                         className="form-select"
//                         value={member.staffId}
//                         onChange={(e) => handleMemberChange(index, 'staffId', e.target.value)}
//                       >
//                         <option value="">Select Staff</option>
//                         {staffList.map((staff) => (
//                           <option key={staff._id} value={String(staff._id)}>
//                             {staff.name || staff.firstName} (ID: {staff._id})
//                           </option>
//                         ))}
//                       </select>
//                     </div>

//                     {/* ✅ Backend se jo bhi role aaya — dynamically show hoga */}
//                     <div className="col-md-4">
//                       <select
//                         className="form-select"
//                         value={member.role}
//                         onChange={(e) => handleMemberChange(index, 'role', e.target.value)}
//                       >
//                         <option value="">Select Role</option>
//                         {member.role && !roleOptions.includes(member.role) && (
//                           <option value={member.role}>{member.role}</option>
//                         )}
//                         {roleOptions.map((role) => (
//                           <option key={role} value={role}>
//                             {role}
//                           </option>
//                         ))}
//                       </select>
//                     </div>

//                     <div className="col-auto">
//                       <button
//                         className="btn btn-outline-danger btn-sm rounded-circle"
//                         style={{ width: 36, height: 36 }}
//                         onClick={() => handleRemoveMember(index)}
//                         title="Remove member"
//                       >
//                         <i className="bi bi-trash3"></i>
//                       </button>
//                     </div>
//                   </div>
//                 ))}

//                 <button
//                   className="btn btn-outline-primary btn-sm rounded-pill mt-2"
//                   onClick={handleAddMember}
//                 >
//                   <i className="bi bi-plus-circle me-1"></i>
//                   Add More +
//                 </button>
//               </div>

//               {/* ── Dates ── */}
//               <div className="mb-5">
//                 <h5 className="fw-bold text-primary mb-3">
//                   <i className="bi bi-calendar-range-fill me-2"></i>
//                   Project Duration
//                 </h5>
//                 <div className="row g-3">
//                   <div className="col-md-6">
//                     <label className="form-label text-muted fw-semibold">
//                       <i className="bi bi-calendar-check me-1"></i>
//                       Start Date
//                     </label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       value={startDate}
//                       onChange={(e) => setStartDate(e.target.value)}
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label text-muted fw-semibold">
//                       <i className="bi bi-calendar-x me-1"></i>
//                       End Date
//                     </label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       value={endDate}
//                       onChange={(e) => setEndDate(e.target.value)}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── Submit ── */}
//               <div className="d-flex gap-3">
//                 <button
//                   className="btn btn-success px-4 py-2 rounded-pill d-flex align-items-center gap-2"
//                   onClick={handleSubmit}
//                   disabled={submitLoading}
//                 >
//                   {submitLoading ? (
//                     <>
//                       <div className="spinner-border spinner-border-sm" role="status">
//                         <span className="visually-hidden">Loading...</span>
//                       </div>
//                       <span>Updating...</span>
//                     </>
//                   ) : (
//                     <>
//                       <i className="bi bi-check-circle-fill"></i>
//                       <span>Update Team</span>
//                     </>
//                   )}
//                 </button>

//                 <button
//                   className="btn btn-outline-secondary px-4 py-2 rounded-pill"
//                   onClick={() => navigate(-1)}
//                   disabled={submitLoading}
//                 >
//                   Cancel
//                 </button>
//               </div>

//             </div>
//           </div>
//         )}
//       </Container>
//     </>
//   );
// };

// export default EditTeamPage;














// import React, { useEffect, useState } from 'react';
// import { Helmet } from 'react-helmet-async';
// import { useParams, useNavigate } from 'react-router-dom';
// import { Container, Typography, Stack } from '@mui/material';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { Url } from 'src/url/url';

// const EditTeamPage = () => {
//   const { projectId } = useParams();
//   const navigate = useNavigate();

//   const [loading, setLoading]             = useState(true);
//   const [submitLoading, setSubmitLoading] = useState(false);

//   const [assistant, setAssistant] = useState({
//     staffId:   '',
//     staffName: '',
//     role:      'assistant',
//   });

//   const [teamMembers, setTeamMembers] = useState([
//     { staffId: '', staffName: '', role: '' },
//   ]);

//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate]     = useState('');

//   useEffect(() => {
//     if (!projectId) return;
//     fetchTeamData();
//   }, [projectId]);

//   const fetchTeamData = async () => {
//     setLoading(true);
//     try {
//       const res  = await axios.get(`${Url}/team/single/${projectId}`);
//       const data = res.data;

//       // ✅ Assistant prefill — staffId object se _id nikalo
//       if (data.assistant) {
//         setAssistant({
//           staffId:   String(data.assistant.staffId?._id || data.assistant.staffId || ''),
//           staffName: data.assistant.staffName || '',
//           role:      data.assistant.role || 'assistant',
//         });
//       }

//       // ✅ Team members prefill
//       if (data.team && data.team.length > 0) {
//         setTeamMembers(
//           data.team.map((m) => ({
//             staffId:   String(m.staffId?._id || m.staffId || ''),
//             staffName: m.staffName || '',
//             role:      m.role || '',
//           }))
//         );
//       }

//       // ✅ Project dates
//       if (data.projectId) {
//         try {
//           const projectRes = await axios.get(`${Url}/project/${data.projectId}`);
//           const project    = projectRes.data;
//           if (project.startAt) setStartDate(project.startAt.slice(0, 10));
//           if (project.endAt)   setEndDate(project.endAt.slice(0, 10));
//         } catch (projErr) {
//           console.error('Project fetch error:', projErr);
//         }
//       }

//     } catch (err) {
//       console.error('Error fetching team:', err);
//       toast.error('Failed to load team data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ─── Assistant handler ────────────────────────────────────────────────────
//   const handleAssistantChange = (e) => {
//     setAssistant((prev) => ({ ...prev, staffId: e.target.value }));
//   };

//   // ─── Team member handlers ─────────────────────────────────────────────────
//   const handleMemberChange = (index, field, value) => {
//     const updated = [...teamMembers];
//     updated[index][field] = value;
//     setTeamMembers(updated);
//   };

//   const handleAddMember = () => {
//     setTeamMembers([...teamMembers, { staffId: '', staffName: '', role: '' }]);
//   };

//   const handleRemoveMember = (index) => {
//     if (teamMembers.length === 1) {
//       toast.warning('At least one team member is required');
//       return;
//     }
//     setTeamMembers(teamMembers.filter((_, i) => i !== index));
//   };

//   // ─── Submit ───────────────────────────────────────────────────────────────
//   const handleSubmit = async () => {
//     if (!assistant.staffId) {
//       toast.error('Please select an assistant');
//       return;
//     }
//     for (let i = 0; i < teamMembers.length; i++) {
//       if (!teamMembers[i].staffId || !teamMembers[i].role) {
//         toast.error(`Please fill all fields for member ${i + 1}`);
//         return;
//       }
//     }
//     if (!startDate || !endDate) {
//       toast.error('Please select start and end dates');
//       return;
//     }

//     setSubmitLoading(true);
//     try {
//       const payload = {
//         assistant,
//         team: teamMembers,
//         startDate,
//         endDate,
//       };

//       const res = await axios.put(`${Url}/team/update/${projectId}`, payload);

//       if (res.data.message) {
//         toast.success('Team updated successfully!');
//         setTimeout(() => navigate('/dashboard/new-project'), 1500);
//       }
//     } catch (err) {
//       console.error('Update error:', err);
//       toast.error(err.response?.data?.message || 'Failed to update team');
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   const roleOptions = [
//     'web developer',
//     'Developer',
//     'Designer',
//     'SEO Specialist',
//     'Content Writer',
//     'Project Manager',
//     'QA Tester',
//     'Marketing',
//     'Other',
//   ];

//   return (
//     <>
//       <ToastContainer />
//       <Helmet>
//         <title>Edit Team</title>
//       </Helmet>

//       <Container maxWidth="lg">
//         <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
//           <Typography variant="h4" gutterBottom>
//             ✏️ Edit Team
//           </Typography>
//           <button
//             className="btn btn-outline-secondary btn-sm rounded-pill"
//             onClick={() => navigate(-1)}
//           >
//             ← Back
//           </button>
//         </Stack>

//         {loading ? (
//           <div className="d-flex justify-content-center align-items-center py-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <span className="ms-3 text-muted">Loading team data...</span>
//           </div>
//         ) : (
//           <div className="card shadow-sm rounded-4 border-0">
//             <div className="card-body p-4">

//               {/* ── Assistant ── */}
//               <div className="mb-5">
//                 <h5 className="fw-bold text-primary mb-3">
//                   <i className="bi bi-person-badge-fill me-2"></i>
//                   Choose Your Assistant
//                 </h5>
//                 <div className="row g-3 align-items-center">
//                   <div className="col-md-3">
//                     <input
//                       type="text"
//                       className="form-control bg-light"
//                       value="assistant"
//                       readOnly
//                     />
//                   </div>

//                   {/* ✅ Assistant name directly show karo — staffName already hai */}
//                   <div className="col-md-5">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={assistant.staffName}
//                       onChange={(e) =>
//                         setAssistant((prev) => ({ ...prev, staffName: e.target.value }))
//                       }
//                       placeholder="Assistant name"
//                     />
//                   </div>

//                   <div className="col-md-4">
//                     <input
//                       type="text"
//                       className="form-control bg-light"
//                       value="Assistant"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── Team Members ── */}
//               <div className="mb-5">
//                 <h5 className="fw-bold text-primary mb-3">
//                   <i className="bi bi-people-fill me-2"></i>
//                   Team Members
//                 </h5>

//                 {teamMembers.map((member, index) => (
//                   <div
//                     key={index}
//                     className="row g-3 align-items-center mb-3 p-3 rounded-3"
//                     style={{ background: '#f8f9fa', border: '1px solid #e9ecef' }}
//                   >
//                     <div className="col-auto">
//                       <span
//                         className="badge bg-primary rounded-circle d-flex align-items-center justify-content-center"
//                         style={{ width: 32, height: 32, fontSize: '0.85rem' }}
//                       >
//                         {index + 1}
//                       </span>
//                     </div>

//                     {/* ✅ Staff name directly show karo */}
//                     <div className="col-md-4">
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={member.staffName}
//                         onChange={(e) => handleMemberChange(index, 'staffName', e.target.value)}
//                         placeholder="Staff name"
//                       />
//                     </div>

//                     {/* ✅ Role dropdown — existing role bhi show hoga */}
//                     <div className="col-md-4">
//                       <select
//                         className="form-select"
//                         value={member.role}
//                         onChange={(e) => handleMemberChange(index, 'role', e.target.value)}
//                       >
//                         <option value="">Select Role</option>
//                         {member.role && !roleOptions.includes(member.role) && (
//                           <option value={member.role}>{member.role}</option>
//                         )}
//                         {roleOptions.map((role) => (
//                           <option key={role} value={role}>
//                             {role}
//                           </option>
//                         ))}
//                       </select>
//                     </div>

//                     <div className="col-auto">
//                       <button
//                         className="btn btn-outline-danger btn-sm rounded-circle"
//                         style={{ width: 36, height: 36 }}
//                         onClick={() => handleRemoveMember(index)}
//                         title="Remove member"
//                       >
//                         <i className="bi bi-trash3"></i>
//                       </button>
//                     </div>
//                   </div>
//                 ))}

//                 <button
//                   className="btn btn-outline-primary btn-sm rounded-pill mt-2"
//                   onClick={handleAddMember}
//                 >
//                   <i className="bi bi-plus-circle me-1"></i>
//                   Add More +
//                 </button>
//               </div>

//               {/* ── Dates ── */}
//               <div className="mb-5">
//                 <h5 className="fw-bold text-primary mb-3">
//                   <i className="bi bi-calendar-range-fill me-2"></i>
//                   Project Duration
//                 </h5>
//                 <div className="row g-3">
//                   <div className="col-md-6">
//                     <label className="form-label text-muted fw-semibold">
//                       <i className="bi bi-calendar-check me-1"></i>
//                       Start Date
//                     </label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       value={startDate}
//                       onChange={(e) => setStartDate(e.target.value)}
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label text-muted fw-semibold">
//                       <i className="bi bi-calendar-x me-1"></i>
//                       End Date
//                     </label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       value={endDate}
//                       onChange={(e) => setEndDate(e.target.value)}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── Submit ── */}
//               <div className="d-flex gap-3">
//                 <button
//                   className="btn btn-success px-4 py-2 rounded-pill d-flex align-items-center gap-2"
//                   onClick={handleSubmit}
//                   disabled={submitLoading}
//                 >
//                   {submitLoading ? (
//                     <>
//                       <div className="spinner-border spinner-border-sm" role="status">
//                         <span className="visually-hidden">Loading...</span>
//                       </div>
//                       <span>Updating...</span>
//                     </>
//                   ) : (
//                     <>
//                       <i className="bi bi-check-circle-fill"></i>
//                       <span>Update Team</span>
//                     </>
//                   )}
//                 </button>

//                 <button
//                   className="btn btn-outline-secondary px-4 py-2 rounded-pill"
//                   onClick={() => navigate(-1)}
//                   disabled={submitLoading}
//                 >
//                   Cancel
//                 </button>
//               </div>

//             </div>
//           </div>
//         )}
//       </Container>
//     </>
//   );
// };

// export default EditTeamPage;









// import React, { useEffect, useState } from 'react';
// import { Helmet } from 'react-helmet-async';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   Container,
//   Typography,
//   Stack,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   CircularProgress,
//   Box,
//   Avatar,
//   Rating,
// } from '@mui/material';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { useSelector } from 'react-redux';
// import { Url } from 'src/url/url';

// const EditTeamPage = () => {
//   const { projectId } = useParams();
//   const navigate = useNavigate();

//   // ── Redux store se staff aur roles ──────────────────────────────────────
//   const staffAllData = useSelector((store) => store.staff.data.data);
//   const roleAllData  = useSelector((store) => store.role.data);

//   const [loading, setLoading]             = useState(true);
//   const [submitLoading, setSubmitLoading] = useState(false);

//   const [assistant, setAssistant] = useState({
//     staffId:   '',
//     staffName: '',
//     role:      'assistant',
//   });

//   const [teamMembers, setTeamMembers] = useState([
//     { staffId: '', staffName: '', role: '' },
//   ]);

//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate]     = useState('');

//   // ── Data fetch ───────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (!projectId) return;
//     fetchTeamData();
//   }, [projectId]);

//   const fetchTeamData = async () => {
//     setLoading(true);
//     try {
//       const res  = await axios.get(`${Url}/team/single/${projectId}`);
//       const data = res.data;

//       if (data.assistant) {
//         setAssistant({
//           staffId:   String(data.assistant.staffId?._id || data.assistant.staffId || ''),
//           staffName: data.assistant.staffName || '',
//           role:      data.assistant.role || 'assistant',
//         });
//       }

//       if (data.team && data.team.length > 0) {
//         setTeamMembers(
//           data.team.map((m) => ({
//             staffId:   String(m.staffId?._id || m.staffId || ''),
//             staffName: m.staffName || '',
//             role:      m.role || '',
//           }))
//         );
//       }

//       if (data.projectId) {
//         try {
//           const projectRes = await axios.get(`${Url}/project/${data.projectId}`);
//           const project    = projectRes.data;
//           if (project.startAt) setStartDate(project.startAt.slice(0, 10));
//           if (project.endAt)   setEndDate(project.endAt.slice(0, 10));
//         } catch (projErr) {
//           console.error('Project fetch error:', projErr);
//         }
//       }
//     } catch (err) {
//       console.error('Error fetching team:', err);
//       toast.error('Failed to load team data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ── Staff MenuItem renderer (reusable) ───────────────────────────────────
//   const renderStaffMenuItem = (staff, isAssistantRole = false) => {
//     const running     = staff.projectIds?.length || 0;
//     const limit       = isAssistantRole ? 20 : 10;
//     const progress    = Math.min((running / limit) * 100, 100);
//     const isOverloaded = running >= limit;

//     return (
//       <MenuItem
//         key={staff._id}
//         value={JSON.stringify(staff)}
//         disabled={isOverloaded}
//         sx={{
//           display:    'flex',
//           alignItems: 'center',
//           gap:        1.5,
//           opacity:    isOverloaded ? 0.6 : 1,
//         }}
//       >
//         <Avatar sx={{ width: 28, height: 28, bgcolor: 'primary.main', fontSize: 13 }}>
//           {staff.firstName?.charAt(0)?.toUpperCase()}
//         </Avatar>

//         <Box flexGrow={1}>
//           <Typography variant="body2" sx={{ fontWeight: 500 }}>
//             {staff.firstName} {staff.lastName}
//           </Typography>
//           <Rating
//             name="read-only"
//             value={Number(staff.avgRating || 0)}
//             precision={0.5}
//             readOnly
//             size="small"
//           />
//         </Box>

//         <Box position="relative" display="inline-flex">
//           <CircularProgress
//             variant="determinate"
//             value={progress}
//             size={28}
//             thickness={5}
//             sx={{
//               color:
//                 progress < 50
//                   ? 'success.main'
//                   : progress < 80
//                   ? 'warning.main'
//                   : 'error.main',
//             }}
//           />
//           <Box
//             top={0} left={0} bottom={0} right={0}
//             position="absolute"
//             display="flex"
//             alignItems="center"
//             justifyContent="center"
//           >
//             <Typography variant="caption" component="div" color="text.secondary" fontSize={10}>
//               {running}
//             </Typography>
//           </Box>
//         </Box>
//       </MenuItem>
//     );
//   };

//   // ── Assistant change ─────────────────────────────────────────────────────
//   const handleAssistantChange = (e) => {
//     const staff = JSON.parse(e.target.value);
//     setAssistant({
//       role:      'assistant',
//       staffId:   staff._id,
//       staffName: `${staff.firstName} ${staff.lastName}`,
//     });
//   };

//   // ── Team member role change ──────────────────────────────────────────────
//   const handleRoleChange = (index, selectedRole) => {
//     const updated = [...teamMembers];
//     updated[index].role      = selectedRole;
//     updated[index].staffId   = '';
//     updated[index].staffName = '';
//     setTeamMembers(updated);
//   };

//   // ── Team member staff change ─────────────────────────────────────────────
//   const handleStaffChange = (e, index) => {
//     const staff   = JSON.parse(e.target.value);
//     const updated = [...teamMembers];
//     updated[index].staffId   = staff._id;
//     updated[index].staffName = `${staff.firstName} ${staff.lastName}`;
//     setTeamMembers(updated);
//   };

//   const handleAddMember = () => {
//     setTeamMembers([...teamMembers, { staffId: '', staffName: '', role: '' }]);
//   };

//   const handleRemoveMember = (index) => {
//     if (teamMembers.length === 1) {
//       toast.warning('At least one team member is required');
//       return;
//     }
//     setTeamMembers(teamMembers.filter((_, i) => i !== index));
//   };

//   // ── Submit ───────────────────────────────────────────────────────────────
//   const handleSubmit = async () => {
//     if (!assistant.staffId) {
//       toast.error('Please select an assistant');
//       return;
//     }
//     for (let i = 0; i < teamMembers.length; i++) {
//       if (!teamMembers[i].staffId || !teamMembers[i].role) {
//         toast.error(`Please fill all fields for member ${i + 1}`);
//         return;
//       }
//     }
//     if (!startDate || !endDate) {
//       toast.error('Please select start and end dates');
//       return;
//     }

//     setSubmitLoading(true);
//     try {
//       const payload = { assistant, team: teamMembers, startDate, endDate };
//       const res     = await axios.put(`${Url}/team/update/${projectId}`, payload);
//       if (res.data.message) {
//         toast.success('Team updated successfully!');
//         setTimeout(() => navigate('/dashboard/new-project'), 1500);
//       }
//     } catch (err) {
//       console.error('Update error:', err);
//       toast.error(err.response?.data?.message || 'Failed to update team');
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   // ────────────────────────────────────────────────────────────────────────
//   return (
//     <>
//       <ToastContainer />
//       <Helmet>
//         <title>Edit Team</title>
//       </Helmet>

//       <Container maxWidth="lg">
//         <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
//           <Typography variant="h4" className="text-dark fw-bold">
//             ✏️ Edit Your Dream Team
//           </Typography>
//           <button
//             className="btn btn-outline-secondary btn-sm rounded-pill"
//             onClick={() => navigate(-1)}
//           >
//             ← Back
//           </button>
//         </Stack>

//         {loading ? (
//           <div className="d-flex justify-content-center align-items-center py-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <span className="ms-3 text-muted">Loading team data...</span>
//           </div>
//         ) : (
//           <div className="team-form-section bg-white p-4 rounded-4 shadow-lg mb-5">
//             <h5 className="text-primary mb-4 fw-semibold">👥 Update Your Team</h5>

//             {/* ── Assistant Select (Dynamic) ────────────────────────────── */}
//             <div className="row mb-4">
//               <div className="col-md-4">
//                 <input type="text" value="assistant" className="form-control" readOnly />
//               </div>
//               <div className="col-md-4">
//                 <FormControl fullWidth size="small">
//                   <InputLabel>Select Assistant</InputLabel>
//                   <Select
//                     value={
//                       assistant.staffId
//                         ? JSON.stringify(
//                             staffAllData?.find((s) => s._id === assistant.staffId) || {}
//                           )
//                         : ''
//                     }
//                     label="Select Assistant"
//                     onChange={handleAssistantChange}
//                     renderValue={() =>
//                       assistant.staffName || 'Select Assistant'
//                     }
//                   >
//                     {staffAllData
//                       ?.filter((s) => s.role === 'assistant')
//                       .map((staff) => renderStaffMenuItem(staff, true))}
//                   </Select>
//                 </FormControl>
//               </div>
//             </div>

//             {/* ── Team Members (Dynamic) ───────────────────────────────── */}
//             {teamMembers.map((pair, idx) => (
//               <div key={idx} className="row mb-3 align-items-center">
//                 {/* Role dropdown */}
//                 <div className="col-md-4">
//                   <select
//                     className="form-select"
//                     value={pair.role}
//                     onChange={(e) => handleRoleChange(idx, e.target.value)}
//                   >
//                     <option value="">Select Role</option>
//                     {roleAllData?.map((role) => (
//                       <option key={role._id} value={role.role}>
//                         {role.role}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 {/* Staff dropdown — role select hone ke baad show hoga */}
//                 <div className="col-md-4">
//                   {pair.role && (
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Select Staff</InputLabel>
//                       <Select
//                         value={
//                           pair.staffId
//                             ? JSON.stringify(
//                                 staffAllData?.find((s) => s._id === pair.staffId) || {}
//                               )
//                             : ''
//                         }
//                         label="Select Staff"
//                         onChange={(e) => handleStaffChange(e, idx)}
//                         renderValue={() =>
//                           pair.staffName || 'Select Staff'
//                         }
//                       >
//                         {staffAllData
//                           ?.filter((staff) => staff.role === pair.role)
//                           .map((staff) => renderStaffMenuItem(staff, false))}
//                       </Select>
//                     </FormControl>
//                   )}
//                 </div>

//                 {/* Remove button */}
//                 <div className="col-md-4">
//                   {teamMembers.length > 1 && (
//                     <button
//                       className="btn btn-outline-danger"
//                       onClick={() => handleRemoveMember(idx)}
//                     >
//                       Remove
//                     </button>
//                   )}
//                 </div>
//               </div>
//             ))}

//             <div className="mb-3">
//               <button className="btn btn-outline-primary me-2" onClick={handleAddMember}>
//                 Add More +
//               </button>
//             </div>

//             {/* ── Dates ────────────────────────────────────────────────── */}
//             <div className="row">
//               <div className="col-md-6 mb-4">
//                 <label className="form-label text-primary fs-14">📅 Select Start Date</label>
//                 <input
//                   type="date"
//                   className="form-control"
//                   value={startDate}
//                   onChange={(e) => setStartDate(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-6 mb-4">
//                 <label className="form-label text-primary fs-14">📅 Select End Date</label>
//                 <input
//                   type="date"
//                   className="form-control"
//                   value={endDate}
//                   min={startDate}
//                   onChange={(e) => setEndDate(e.target.value)}
//                 />
//               </div>
//             </div>

//             {/* ── Submit ───────────────────────────────────────────────── */}
//             <div className="d-flex gap-3">
//               <button
//                 className="btn btn-success px-4 py-2 rounded-pill d-flex align-items-center gap-2"
//                 onClick={handleSubmit}
//                 disabled={submitLoading}
//               >
//                 {submitLoading ? (
//                   <>
//                     <div className="spinner-border spinner-border-sm" role="status">
//                       <span className="visually-hidden">Loading...</span>
//                     </div>
//                     <span>Updating...</span>
//                   </>
//                 ) : (
//                   <>
//                     <i className="bi bi-check-circle-fill"></i>
//                     <span>Update Team <i className="fa-solid fa-user-plus ms-2"></i></span>
//                   </>
//                 )}
//               </button>

//               <button
//                 className="btn btn-outline-secondary px-4 py-2 rounded-pill"
//                 onClick={() => navigate(-1)}
//                 disabled={submitLoading}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         )}
//       </Container>
//     </>
//   );
// };

// export default EditTeamPage;










// import React, { useEffect, useState } from 'react';
// import { Helmet } from 'react-helmet-async';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   Container,
//   Typography,
//   Stack,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   CircularProgress,
//   Box,
//   Avatar,
//   Rating,
// } from '@mui/material';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { useSelector } from 'react-redux';
// import { Url } from 'src/url/url';

// const EditTeamPage = () => {
//   const { projectId } = useParams();
//   const navigate = useNavigate();

//   // ── Redux store se staff aur roles ──────────────────────────────────────
//   const staffAllData = useSelector((store) => store.staff.data.data);
//   const roleAllData  = useSelector((store) => store.role.data);

//   const [loading, setLoading]             = useState(true);
//   const [submitLoading, setSubmitLoading] = useState(false);

//   const [assistant, setAssistant] = useState({
//     staffId:   '',
//     staffName: '',
//     role:      'assistant',
//   });

//   const [teamMembers, setTeamMembers] = useState([
//     { staffId: '', staffName: '', role: '' },
//   ]);



//   // ── Data fetch ───────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (!projectId) return;
//     fetchTeamData();
//   }, [projectId]);

//   const fetchTeamData = async () => {
//     setLoading(true);
//     try {
//       const res  = await axios.get(`${Url}/team/single/${projectId}`);
//       const data = res.data;

//       if (data.assistant) {
//         setAssistant({
//           staffId:   String(data.assistant.staffId?._id || data.assistant.staffId || ''),
//           staffName: data.assistant.staffName || '',
//           role:      data.assistant.role || 'assistant',
//         });
//       }

//       if (data.team && data.team.length > 0) {
//         setTeamMembers(
//           data.team.map((m) => ({
//             staffId:   String(m.staffId?._id || m.staffId || ''),
//             staffName: m.staffName || '',
//             role:      m.role || '',
//           }))
//         );
//       }


//     } catch (err) {
//       console.error('Error fetching team:', err);
//       toast.error('Failed to load team data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ── Staff MenuItem renderer (reusable) ───────────────────────────────────
//   const renderStaffMenuItem = (staff, isAssistantRole = false) => {
//     const running     = staff.projectIds?.length || 0;
//     const limit       = isAssistantRole ? 20 : 10;
//     const progress    = Math.min((running / limit) * 100, 100);
//     const isOverloaded = running >= limit;

//     return (
//       <MenuItem
//         key={staff._id}
//         value={JSON.stringify(staff)}
//         disabled={isOverloaded}
//         sx={{
//           display:    'flex',
//           alignItems: 'center',
//           gap:        1.5,
//           opacity:    isOverloaded ? 0.6 : 1,
//         }}
//       >
//         <Avatar sx={{ width: 28, height: 28, bgcolor: 'primary.main', fontSize: 13 }}>
//           {staff.firstName?.charAt(0)?.toUpperCase()}
//         </Avatar>

//         <Box flexGrow={1}>
//           <Typography variant="body2" sx={{ fontWeight: 500 }}>
//             {staff.firstName} {staff.lastName}
//           </Typography>
//           <Rating
//             name="read-only"
//             value={Number(staff.avgRating || 0)}
//             precision={0.5}
//             readOnly
//             size="small"
//           />
//         </Box>

//         <Box position="relative" display="inline-flex">
//           <CircularProgress
//             variant="determinate"
//             value={progress}
//             size={28}
//             thickness={5}
//             sx={{
//               color:
//                 progress < 50
//                   ? 'success.main'
//                   : progress < 80
//                   ? 'warning.main'
//                   : 'error.main',
//             }}
//           />
//           <Box
//             top={0} left={0} bottom={0} right={0}
//             position="absolute"
//             display="flex"
//             alignItems="center"
//             justifyContent="center"
//           >
//             <Typography variant="caption" component="div" color="text.secondary" fontSize={10}>
//               {running}
//             </Typography>
//           </Box>
//         </Box>
//       </MenuItem>
//     );
//   };

//   // ── Assistant change ─────────────────────────────────────────────────────
//   const handleAssistantChange = (e) => {
//     const staff = JSON.parse(e.target.value);
//     setAssistant({
//       role:      'assistant',
//       staffId:   staff._id,
//       staffName: `${staff.firstName} ${staff.lastName}`,
//     });
//   };

//   // ── Team member role change ──────────────────────────────────────────────
//   const handleRoleChange = (index, selectedRole) => {
//     const updated = [...teamMembers];
//     updated[index].role      = selectedRole;
//     updated[index].staffId   = '';
//     updated[index].staffName = '';
//     setTeamMembers(updated);
//   };

//   // ── Team member staff change ─────────────────────────────────────────────
//   const handleStaffChange = (e, index) => {
//     const staff   = JSON.parse(e.target.value);
//     const updated = [...teamMembers];
//     updated[index].staffId   = staff._id;
//     updated[index].staffName = `${staff.firstName} ${staff.lastName}`;
//     setTeamMembers(updated);
//   };

//   const handleAddMember = () => {
//     setTeamMembers([...teamMembers, { staffId: '', staffName: '', role: '' }]);
//   };

//   const handleRemoveMember = (index) => {
//     if (teamMembers.length === 1) {
//       toast.warning('At least one team member is required');
//       return;
//     }
//     setTeamMembers(teamMembers.filter((_, i) => i !== index));
//   };

//   // ── Submit ───────────────────────────────────────────────────────────────
//   const handleSubmit = async () => {
//     if (!assistant.staffId) {
//       toast.error('Please select an assistant');
//       return;
//     }
//     for (let i = 0; i < teamMembers.length; i++) {
//       if (!teamMembers[i].staffId || !teamMembers[i].role) {
//         toast.error(`Please fill all fields for member ${i + 1}`);
//         return;
//       }
//     }

//     setSubmitLoading(true);
//     try {
//       const payload = { assistant, team: teamMembers };
//       const res     = await axios.put(`${Url}/team/update/${projectId}`, payload);
//       if (res.data.message) {
//         toast.success('Team updated successfully!');
//         // setTimeout(() => navigate('/dashboard/new-project'), 1500);
//         // window.location.reload()
//       }
//     } catch (err) {
//       console.error('Update error:', err);
//       toast.error(err.response?.data?.message || 'Failed to update team');
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   // ────────────────────────────────────────────────────────────────────────
//   return (
//     <>
//       <ToastContainer />
//       <Helmet>
//         <title>Edit Team</title>
//       </Helmet>

//       <Container maxWidth="lg">
//         <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
//           <Typography variant="h4" className="text-dark fw-bold">
//             ✏️ Edit Your Dream Team
//           </Typography>
//           <button
//             className="btn btn-outline-secondary btn-sm rounded-pill"
//             onClick={() => navigate(-1)}
//           >
//             ← Back
//           </button>
//         </Stack>

//         {loading ? (
//           <div className="d-flex justify-content-center align-items-center py-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <span className="ms-3 text-muted">Loading team data...</span>
//           </div>
//         ) : (
//           <div className="team-form-section bg-white p-4 rounded-4 shadow-lg mb-5">
//             <h5 className="text-primary mb-4 fw-semibold">👥 Update Your Team</h5>

//             {/* ── Assistant Select (Dynamic) ────────────────────────────── */}
//             <div className="row mb-4">
//               <div className="col-md-4">
//                 <input type="text" value="assistant" className="form-control" readOnly />
//               </div>
//               <div className="col-md-4">
//                 <FormControl fullWidth size="small">
//                   <InputLabel>Select Assistant</InputLabel>
//                   <Select
//                     value={
//                       assistant.staffId
//                         ? JSON.stringify(
//                             staffAllData?.find((s) => s._id === assistant.staffId) || {}
//                           )
//                         : ''
//                     }
//                     label="Select Assistant"
//                     onChange={handleAssistantChange}
//                     renderValue={() =>
//                       assistant.staffName || 'Select Assistant'
//                     }
//                   >
//                     {staffAllData
//                       ?.filter((s) => s.role === 'assistant')
//                       .map((staff) => renderStaffMenuItem(staff, true))}
//                   </Select>
//                 </FormControl>
//               </div>
//             </div>

//             {/* ── Team Members (Dynamic) ───────────────────────────────── */}
//             {teamMembers.map((pair, idx) => (
//               <div key={idx} className="row mb-3 align-items-center">
//                 {/* Role dropdown */}
//                 <div className="col-md-4">
//                   <select
//                     className="form-select"
//                     value={pair.role}
//                     onChange={(e) => handleRoleChange(idx, e.target.value)}
//                   >
//                     <option value="">Select Role</option>
//                     {roleAllData?.map((role) => (
//                       <option key={role._id} value={role.role}>
//                         {role.role}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 {/* Staff dropdown — role select hone ke baad show hoga */}
//                 <div className="col-md-4">
//                   {pair.role && (
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Select Staff</InputLabel>
//                       <Select
//                         value={
//                           pair.staffId
//                             ? JSON.stringify(
//                                 staffAllData?.find((s) => s._id === pair.staffId) || {}
//                               )
//                             : ''
//                         }
//                         label="Select Staff"
//                         onChange={(e) => handleStaffChange(e, idx)}
//                         renderValue={() =>
//                           pair.staffName || 'Select Staff'
//                         }
//                       >
//                         {staffAllData
//                           ?.filter((staff) => staff.role === pair.role)
//                           .map((staff) => renderStaffMenuItem(staff, false))}
//                       </Select>
//                     </FormControl>
//                   )}
//                 </div>

//                 {/* Remove button */}
//                 <div className="col-md-4">
//                   {teamMembers.length > 1 && (
//                     <button
//                       className="btn btn-outline-danger"
//                       onClick={() => handleRemoveMember(idx)}
//                     >
//                       Remove
//                     </button>
//                   )}
//                 </div>
//               </div>
//             ))}

//             <div className="mb-3">
//               <button className="btn btn-outline-primary me-2" onClick={handleAddMember}>
//                 Add More +
//               </button>
//             </div>


//             {/* ── Submit ───────────────────────────────────────────────── */}
//             <div className="d-flex gap-3">
//               <button
//                 className="btn btn-success px-4 py-2 rounded-pill d-flex align-items-center gap-2"
//                 onClick={handleSubmit}
//                 disabled={submitLoading}
//               >
//                 {submitLoading ? (
//                   <>
//                     <div className="spinner-border spinner-border-sm" role="status">
//                       <span className="visually-hidden">Loading...</span>
//                     </div>
//                     <span>Updating...</span>
//                   </>
//                 ) : (
//                   <>
//                     <i className="bi bi-check-circle-fill"></i>
//                     <span>Update Team <i className="fa-solid fa-user-plus ms-2"></i></span>
//                   </>
//                 )}
//               </button>

//               <button
//                 className="btn btn-outline-secondary px-4 py-2 rounded-pill"
//                 onClick={() => navigate(-1)}
//                 disabled={submitLoading}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         )}
//       </Container>
//     </>
//   );
// };

// export default EditTeamPage;





// import React, { useEffect, useState } from 'react';
// import { Helmet } from 'react-helmet-async';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   Container,
//   Typography,
//   Stack,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   CircularProgress,
//   Box,
//   Avatar,
//   Rating,
// } from '@mui/material';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { useSelector } from 'react-redux';
// import { Url } from 'src/url/url';

// const EditTeamPage = () => {
//   const { projectId } = useParams();
//   const navigate = useNavigate();

//   // ── Redux store se staff aur roles ──────────────────────────────────────
//   const staffAllData = useSelector((store) => store.staff.data.data);
//   const roleAllData  = useSelector((store) => store.role.data);

//   const [loading, setLoading]             = useState(true);
//   const [submitLoading, setSubmitLoading] = useState(false);

//   const [assistant, setAssistant] = useState({
//     staffId:   '',
//     staffName: '',
//     role:      'assistant',
//   });

//   const [teamMembers, setTeamMembers] = useState([
//     { staffId: '', staffName: '', role: '' },
//   ]);



//   // ── Data fetch ───────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (!projectId) return;
//     fetchTeamData();
//   }, [projectId]);

//   const fetchTeamData = async () => {
//     setLoading(true);
//     try {
//       const res  = await axios.get(`${Url}/team/single/${projectId}`);
//       const data = res.data;

//       if (data.assistant) {
//         setAssistant({
//           staffId:   String(data.assistant.staffId?._id || data.assistant.staffId || ''),
//           staffName: data.assistant.staffName || '',
//           role:      data.assistant.role || 'assistant',
//         });
//       }

//       if (data.team && data.team.length > 0) {
//         setTeamMembers(
//           data.team.map((m) => ({
//             staffId:   String(m.staffId?._id || m.staffId || ''),
//             staffName: m.staffName || '',
//             role:      m.role || '',
//           }))
//         );
//       }


//     } catch (err) {
//       console.error('Error fetching team:', err);
//       toast.error('Failed to load team data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ── Staff MenuItem renderer (reusable) ───────────────────────────────────
//   const renderStaffMenuItem = (staff, isAssistantRole = false) => {
//     const running     = staff.projectIds?.length || 0;
//     const limit       = isAssistantRole ? 20 : 10;
//     const progress    = Math.min((running / limit) * 100, 100);
//     const isOverloaded = running >= limit;

//     return (
//       <MenuItem
//         key={staff._id}
//         value={JSON.stringify(staff)}
//         disabled={isOverloaded}
//         sx={{
//           display:    'flex',
//           alignItems: 'center',
//           gap:        1.5,
//           opacity:    isOverloaded ? 0.6 : 1,
//         }}
//       >
//         <Avatar sx={{ width: 28, height: 28, bgcolor: 'primary.main', fontSize: 13 }}>
//           {staff.firstName?.charAt(0)?.toUpperCase()}
//         </Avatar>

//         <Box flexGrow={1}>
//           <Typography variant="body2" sx={{ fontWeight: 500 }}>
//             {staff.firstName} {staff.lastName}
//           </Typography>
//           <Rating
//             name="read-only"
//             value={Number(staff.avgRating || 0)}
//             precision={0.5}
//             readOnly
//             size="small"
//           />
//         </Box>

//         <Box position="relative" display="inline-flex">
//           <CircularProgress
//             variant="determinate"
//             value={progress}
//             size={28}
//             thickness={5}
//             sx={{
//               color:
//                 progress < 50
//                   ? 'success.main'
//                   : progress < 80
//                   ? 'warning.main'
//                   : 'error.main',
//             }}
//           />
//           <Box
//             top={0} left={0} bottom={0} right={0}
//             position="absolute"
//             display="flex"
//             alignItems="center"
//             justifyContent="center"
//           >
//             <Typography variant="caption" component="div" color="text.secondary" fontSize={10}>
//               {running}
//             </Typography>
//           </Box>
//         </Box>
//       </MenuItem>
//     );
//   };

//   // ── Assistant change ─────────────────────────────────────────────────────
//   const handleAssistantChange = (e) => {
//     const staff = JSON.parse(e.target.value);
//     setAssistant({
//       role:      'assistant',
//       staffId:   staff._id,
//       staffName: `${staff.firstName} ${staff.lastName}`,
//     });
//   };

//   // ── Team member role change ──────────────────────────────────────────────
//   const handleRoleChange = (index, selectedRole) => {
//     const updated = [...teamMembers];
//     updated[index].role      = selectedRole;
//     updated[index].staffId   = '';
//     updated[index].staffName = '';
//     setTeamMembers(updated);
//   };

//   // ── Team member staff change ─────────────────────────────────────────────
//   const handleStaffChange = (e, index) => {
//     const staff   = JSON.parse(e.target.value);
//     const updated = [...teamMembers];
//     updated[index].staffId   = staff._id;
//     updated[index].staffName = `${staff.firstName} ${staff.lastName}`;
//     setTeamMembers(updated);
//   };

//   const handleAddMember = () => {
//     setTeamMembers([...teamMembers, { staffId: '', staffName: '', role: '' }]);
//   };

//   const handleRemoveMember = (index) => {
//     if (teamMembers.length === 1) {
//       toast.warning('At least one team member is required');
//       return;
//     }
//     setTeamMembers(teamMembers.filter((_, i) => i !== index));
//   };

//   // ── Submit ───────────────────────────────────────────────────────────────
//   const handleSubmit = async () => {
//     if (!assistant.staffId) {
//       toast.error('Please select an assistant');
//       return;
//     }
//     for (let i = 0; i < teamMembers.length; i++) {
//       if (!teamMembers[i].staffId || !teamMembers[i].role) {
//         toast.error(`Please fill all fields for member ${i + 1}`);
//         return;
//       }
//     }

//     setSubmitLoading(true);
//     try {
//       const payload = { assistant, team: teamMembers };
//       const res     = await axios.put(`${Url}/team/update/${projectId}`, payload);
//       if (res.data.message) {
//         toast.success('Team updated successfully!');
//         setTimeout(() => navigate('/dashboard/new-project'), 1500);
//       }
//     } catch (err) {
//       console.error('Update error:', err);
//       toast.error(err.response?.data?.message || 'Failed to update team');
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   // ────────────────────────────────────────────────────────────────────────
//   return (
//     <>
//       <ToastContainer />
//       <Helmet>
//         <title>Edit Team</title>
//       </Helmet>

//       <Container maxWidth="lg">
//         <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
//           <Typography variant="h4" className="text-dark fw-bold">
//             ✏️ Edit Your Dream Team
//           </Typography>
//           <button
//             className="btn btn-outline-secondary btn-sm rounded-pill"
//             onClick={() => navigate(-1)}
//           >
//             ← Back
//           </button>
//         </Stack>

//         {loading ? (
//           <div className="d-flex justify-content-center align-items-center py-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <span className="ms-3 text-muted">Loading team data...</span>
//           </div>
//         ) : (
//           <div className="team-form-section bg-white p-4 rounded-4 shadow-lg mb-5">
//             <h5 className="text-primary mb-4 fw-semibold">👥 Update Your Team</h5>

//             {/* ── Assistant Select (Dynamic) ────────────────────────────── */}
//             <div className="row mb-4">
//               <div className="col-md-4">
//                 <input type="text" value="assistant" className="form-control" readOnly />
//               </div>
//               <div className="col-md-4">
//                 <FormControl fullWidth size="small">
//                   <InputLabel>Select Assistant</InputLabel>
//                   <Select
//                     value={
//                       assistant.staffId
//                         ? JSON.stringify(
//                             staffAllData?.find((s) => s._id === assistant.staffId) || {}
//                           )
//                         : ''
//                     }
//                     label="Select Assistant"
//                     onChange={handleAssistantChange}
//                     renderValue={() =>
//                       assistant.staffName || 'Select Assistant'
//                     }
//                   >
//                     {staffAllData
//                       ?.filter((s) => s.role === 'assistant')
//                       .map((staff) => renderStaffMenuItem(staff, true))}
//                   </Select>
//                 </FormControl>
//               </div>
//             </div>

//             {/* ── Team Members (Dynamic) ───────────────────────────────── */}
//             {teamMembers.map((pair, idx) => (
//               <div key={idx} className="row mb-3 align-items-center">
//                 {/* Role dropdown */}
//                 <div className="col-md-4">
//                   <select
//                     className="form-select"
//                     value={pair.role}
//                     onChange={(e) => handleRoleChange(idx, e.target.value)}
//                   >
//                     <option value="">Select Role</option>
//                     {roleAllData?.map((role) => (
//                       <option key={role._id} value={role.role}>
//                         {role.role}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 {/* Staff dropdown — role select hone ke baad show hoga */}
//                 <div className="col-md-4">
//                   {pair.role && (
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Select Staff</InputLabel>
//                       <Select
//                         value={
//                           pair.staffId
//                             ? JSON.stringify(
//                                 staffAllData?.find((s) => s._id === pair.staffId) || {}
//                               )
//                             : ''
//                         }
//                         label="Select Staff"
//                         onChange={(e) => handleStaffChange(e, idx)}
//                         renderValue={() =>
//                           pair.staffName || 'Select Staff'
//                         }
//                       >
//                         {staffAllData
//                           ?.filter((staff) => staff.role === pair.role)
//                           .map((staff) => renderStaffMenuItem(staff, false))}
//                       </Select>
//                     </FormControl>
//                   )}
//                 </div>

//                 {/* Remove button */}
//                 <div className="col-md-4">
//                   {teamMembers.length > 1 && (
//                     <button
//                       className="btn btn-outline-danger"
//                       onClick={() => handleRemoveMember(idx)}
//                     >
//                       Remove
//                     </button>
//                   )}
//                 </div>
//               </div>
//             ))}

//             <div className="mb-3">
//               <button className="btn btn-outline-primary me-2" onClick={handleAddMember}>
//                 Add More +
//               </button>
//             </div>


//             {/* ── Submit ───────────────────────────────────────────────── */}
//             <div className="d-flex gap-3">
//               <button
//                 className="btn btn-success px-4 py-2 rounded-pill d-flex align-items-center gap-2"
//                 onClick={handleSubmit}
//                 disabled={submitLoading}
//               >
//                 {submitLoading ? (
//                   <>
//                     <div className="spinner-border spinner-border-sm" role="status">
//                       <span className="visually-hidden">Loading...</span>
//                     </div>
//                     <span>Updating...</span>
//                   </>
//                 ) : (
//                   'Update Team ✓'
//                 )}
//               </button>

//               <button
//                 className="btn btn-outline-secondary px-4 py-2 rounded-pill"
//                 onClick={() => navigate(-1)}
//                 disabled={submitLoading}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         )}
//       </Container>
//     </>
//   );
// };

// export default EditTeamPage;












import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container, Typography, Stack, FormControl, InputLabel,
  MenuItem, Select, CircularProgress, Box, Avatar, Rating,
} from '@mui/material';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector, useDispatch } from 'react-redux';
import { Url } from 'src/url/url';
import { teamdata } from 'src/redux/slice/team';
import { projectdata } from 'src/redux/slice/project';

const EditTeamPage = () => {
  const { projectId } = useParams();
  const navigate      = useNavigate();
  const dispatch      = useDispatch();

  const staffAllData = useSelector((store) => store.staff.data.data);
  const roleAllData  = useSelector((store) => store.role.data);

  const [loading, setLoading]             = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [teamId, setTeamId]               = useState(null);

  const [assistant, setAssistant] = useState({
    staffId: '', staffName: '', role: 'assistant',
  });

  const [teamMembers, setTeamMembers] = useState([
    { staffId: '', staffName: '', role: '' },
  ]);

  useEffect(() => {
    if (!projectId) return;
    fetchTeamData();
  }, [projectId]);

  const fetchTeamData = async () => {
    setLoading(true);
    try {
      const res  = await axios.get(`${Url}/team/single/${projectId}`);
      const data = res.data;

      if (data._id) setTeamId(data._id);

      if (data.assistant) {
        setAssistant({
          staffId:   String(data.assistant.staffId?._id || data.assistant.staffId || ''),
          staffName: data.assistant.staffName || '',
          role:      data.assistant.role || 'assistant',
        });
      }

      if (data.team && data.team.length > 0) {
        setTeamMembers(
          data.team.map((m) => ({
            staffId:   String(m.staffId?._id || m.staffId || ''),
            staffName: m.staffName || '',
            role:      m.role || '',
          }))
        );
      }
    } catch (err) {
      console.error('Error fetching team:', err);
      toast.error('Failed to load team data');
    } finally {
      setLoading(false);
    }
  };

  const renderStaffMenuItem = (staff, isAssistantRole = false) => {
    const running      = staff.projectIds?.length || 0;
    const limit        = isAssistantRole ? 20 : 10;
    const progress     = Math.min((running / limit) * 100, 100);
    const isOverloaded = running >= limit;

    return (
      <MenuItem
        key={staff._id}
        value={JSON.stringify(staff)}
        disabled={isOverloaded}
        sx={{ display: 'flex', alignItems: 'center', gap: 1.5, opacity: isOverloaded ? 0.6 : 1 }}
      >
        <Avatar sx={{ width: 28, height: 28, bgcolor: 'primary.main', fontSize: 13 }}>
          {staff.firstName?.charAt(0)?.toUpperCase()}
        </Avatar>
        <Box flexGrow={1}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {staff.firstName} {staff.lastName}
          </Typography>
          <Rating value={Number(staff.avgRating || 0)} precision={0.5} readOnly size="small" />
        </Box>
        <Box position="relative" display="inline-flex">
          <CircularProgress
            variant="determinate" value={progress} size={28} thickness={5}
            sx={{
              color: progress < 50 ? 'success.main' : progress < 80 ? 'warning.main' : 'error.main'
            }}
          />
          <Box top={0} left={0} bottom={0} right={0} position="absolute"
            display="flex" alignItems="center" justifyContent="center">
            <Typography variant="caption" component="div" color="text.secondary" fontSize={10}>
              {running}
            </Typography>
          </Box>
        </Box>
      </MenuItem>
    );
  };

  const handleAssistantChange = (e) => {
    const staff = JSON.parse(e.target.value);
    setAssistant({
      role:      'assistant',
      staffId:   staff._id,
      staffName: `${staff.firstName} ${staff.lastName}`,
    });
  };

  const handleRoleChange = (index, selectedRole) => {
    const updated = [...teamMembers];
    updated[index] = { ...updated[index], role: selectedRole, staffId: '', staffName: '' };
    setTeamMembers(updated);
  };

  const handleStaffChange = (e, index) => {
    const staff   = JSON.parse(e.target.value);
    const updated = [...teamMembers];
    updated[index] = {
      ...updated[index],
      staffId:   staff._id,
      staffName: `${staff.firstName} ${staff.lastName}`,
    };
    setTeamMembers(updated);
  };

  const handleAddMember = () => {
    setTeamMembers([...teamMembers, { staffId: '', staffName: '', role: '' }]);
  };

  const handleRemoveMember = (index) => {
    if (teamMembers.length === 1) {
      toast.warning('At least one team member is required');
      return;
    }
    setTeamMembers(teamMembers.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    if (!assistant.staffId) {
      toast.error('Please select an assistant');
      return;
    }
    for (let i = 0; i < teamMembers.length; i++) {
      if (!teamMembers[i].staffId || !teamMembers[i].role) {
        toast.error(`Please fill all fields for member ${i + 1}`);
        return;
      }
    }
    if (!teamId) {
      toast.error('Team ID missing, please refresh');
      return;
    }

    setSubmitLoading(true);
    try {
      const payload = { assistant, team: teamMembers };

      const res = await axios.put(`${Url}/team/update/${teamId}`, payload);

      if (res.data.message) {
        toast.success('Team updated successfully!');

        // ✅ Redux store refresh karo — taaki sabko turant updated data mile
        dispatch(teamdata());
        dispatch(projectdata());

        setTimeout(() => navigate('/dashboard/new-project'), 1500);
      }
    } catch (err) {
      console.error('Update error:', err);
      toast.error(err.response?.data?.message || 'Failed to update team');
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <Helmet><title>Edit Team</title></Helmet>

      <Container maxWidth="lg">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
          <Typography variant="h4" className="text-dark fw-bold">
            ✏️ Edit Your Dream Team
          </Typography>
          <button
            className="btn btn-outline-secondary btn-sm rounded-pill"
            onClick={() => navigate(-1)}
          >
            ← Back
          </button>
        </Stack>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center py-5">
            <div className="spinner-border text-primary" role="status" />
            <span className="ms-3 text-muted">Loading team data...</span>
          </div>
        ) : (
          <div className="team-form-section bg-white p-4 rounded-4 shadow-lg mb-5">
            <h5 className="text-primary mb-4 fw-semibold">👥 Update Your Team</h5>

            {/* Assistant */}
            <div className="row mb-4">
              <div className="col-md-4">
                <input type="text" value="assistant" className="form-control" readOnly />
              </div>
              <div className="col-md-4">
                <FormControl fullWidth size="small">
                  <InputLabel>Select Assistant</InputLabel>
                  <Select
                    value={
                      assistant.staffId
                        ? JSON.stringify(
                            staffAllData?.find(
                              (s) => String(s._id) === String(assistant.staffId)
                            ) || {}
                          )
                        : ''
                    }
                    label="Select Assistant"
                    onChange={handleAssistantChange}
                    renderValue={() => assistant.staffName || 'Select Assistant'}
                  >
                    {staffAllData
                      ?.filter((s) => s.role === 'assistant')
                      .map((staff) => renderStaffMenuItem(staff, true))}
                  </Select>
                </FormControl>
              </div>
            </div>

            {/* Team Members */}
            {teamMembers.map((pair, idx) => (
              <div key={idx} className="row mb-3 align-items-center">
                <div className="col-md-4">
                  <select
                    className="form-select"
                    value={pair.role}
                    onChange={(e) => handleRoleChange(idx, e.target.value)}
                  >
                    <option value="">Select Role</option>
                    {roleAllData?.map((role) => (
                      <option key={role._id} value={role.role}>{role.role}</option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4">
                  {pair.role && (
                    <FormControl fullWidth size="small">
                      <InputLabel>Select Staff</InputLabel>
                      <Select
                        value={
                          pair.staffId
                            ? JSON.stringify(
                                staffAllData?.find(
                                  (s) => String(s._id) === String(pair.staffId)
                                ) || {}
                              )
                            : ''
                        }
                        label="Select Staff"
                        onChange={(e) => handleStaffChange(e, idx)}
                        renderValue={() => pair.staffName || 'Select Staff'}
                      >
                        {staffAllData
                          ?.filter((s) => s.role === pair.role)
                          .map((s) => renderStaffMenuItem(s, false))}
                      </Select>
                    </FormControl>
                  )}
                </div>

                <div className="col-md-4">
                  {teamMembers.length > 1 && (
                    <button
                      className="btn btn-outline-danger"
                      onClick={() => handleRemoveMember(idx)}
                    >
                      Remove
                    </button>
                  )}
                </div>
              </div>
            ))}

            <div className="mb-3">
              <button className="btn btn-outline-primary me-2" onClick={handleAddMember}>
                Add More +
              </button>
            </div>

            {/* Submit */}
            <div className="d-flex gap-3">
              <button
                className="btn btn-success px-4 py-2 rounded-pill d-flex align-items-center gap-2"
                onClick={handleSubmit}
                disabled={submitLoading}
              >
                {submitLoading ? (
                  <>
                    <div className="spinner-border spinner-border-sm" role="status" />
                    <span>Updating...</span>
                  </>
                ) : 'Update Team ✓'}
              </button>

              <button
                className="btn btn-outline-secondary px-4 py-2 rounded-pill"
                onClick={() => navigate(-1)}
                disabled={submitLoading}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </Container>
    </>
  );
};

export default EditTeamPage;